<template>
  <div>
    <transition :name="transitionName">
      <!--<keep-alive>-->
        <router-view class="child-view"></router-view>
      <!--</keep-alive>-->

    </transition>

  </div>
</template>

<script>
  export default {
    name: 'app',
    data() {
      return {
        transitionName: 'slide-left'
      };
    },
    beforeRouteUpdate(to, from, next) {
      let isBack = this.$router.isBack;
      if (isBack) {
        this.transitionName = 'slide-right';
      } else {
        this.transitionName = 'slide-left';
      }
      this.$router.isBack = false;
      next();
    }
  };
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
  @import "../assets/scss/base.scss";
  /* 可以设置不同的进入和离开动画 */
  /* 设置持续时间和动画函数 */
  .child-view {
    height: 100%;
    position: absolute;
    transition: all .8s cubic-bezier(.55,0,.1,1);
  }

  .slide-left-enter, .slide-right-leave-active {
    opacity: 0;
    -webkit-transform: translate(px2rem(50), 0);
    transform: translate(px2rem(50), 0);
  }

  .slide-left-leave-active, .slide-right-enter {
    opacity: 0;
    -webkit-transform: translate(px2rem(-50), 0);
    transform: translate(px2rem(-50), 0);
  }
</style>




// WEBPACK FOOTER //
// PageTransition.vue?ff209f12